export const LAST_NEWSLETTER_CLOSE_TIME = 'LAST_NEWSLETTER_CLOSE_TIME';

export const LAST_NEWSLETTER_REOPEN_DELAY_MINUTES = 'LAST_NEWSLETTER_REOPEN_DELAY_MINUTES';

export const NEWSLETTER_INTERACTION_EVENTS = ['scroll', 'click', 'keydown', 'touchstart'];

export const CLOSE_TIME_NEWSLETTER_POPUP_ON_MOUNT_IN_MINUTES = 60;

export const HEADER_GALLERY_ASPECT_RATIO_DEFAULTS = {
    MOBILE: 500/633,
    DESKTOP: 2560/650
}